import React from 'react';
import { cn } from '@crabs-ai/ds-react';

function ScriptPropertyPanelContentDivider({
  dashStyle = 'border-dashed',
  children,
}: {
  dashStyle?: 'border-dashed' | 'border-solid';
  children?: React.ReactNode;
}) {
  if (children)
    return (
      <div
        className={
          'flex max-h-7 min-h-7 w-full items-center justify-between gap-2xs'
        }
      >
        <div
          className={
            'max-h-px min-h-px w-full border-t border-sys-style-neutral-default'
          }
        />
        {children && <div className={'min-w-fit'}>{children}</div>}
        <div
          className={
            'max-h-px min-h-px w-full border-t border-sys-style-neutral-default'
          }
        />
      </div>
    );

  return (
    <div
      className={
        'flex max-h-7 min-h-7 w-full items-center justify-between gap-2xs'
      }
    >
      <div
        className={cn(
          'max-h-px min-h-px w-full border-t border-sys-style-neutral-default',
          dashStyle,
        )}
      />
    </div>
  );
}

export default ScriptPropertyPanelContentDivider;
